/** This transformer sets a flag when the user changes a post code in case
 * `basic_coverage_postcode_validation_contents` is truthy. Since we don't know
 * if a new post code will pass this validation, we need to trigger quote
 * with `main_modules2` set to `false` by default.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    if (current.risk_address_postcode_city === previous.risk_address_postcode_city) {
      return;
    }

    const contentsValidation = kasko.getState(
      'quote.data.extraData.basic_coverage_postcode_validation_contents',
    );
    const buildingsValidation = kasko.getState(
      'quote.data.extraData.basic_coverage_postcode_validation_building',
    );
    if (!contentsValidation && !buildingsValidation) {
      return;
    }

    const modules = {};
    if (contentsValidation) {
      modules.main_modules2 = false;
    }
    if (buildingsValidation) {
      modules.fire_basic_coverage = false;
      modules.water_basic_coverage = true;
    }

    kasko.dispatchEvent('set-state-input', {
      postcode_changed: true,
      ...modules,
    });
    kasko.dispatchEvent('set-form-input', {
      ...modules,
    });
  });
};
